import request from '@/common/request'
import { Page, Venda } from '@/models'
import { Carrinho, CarrinhoPublico } from '@/models/venda/Carrinho'
import { AxiosRequestConfig } from 'axios'

const basePath = '/carrinhos'

export const criarCarrinho = async (carrinho: Carrinho): Promise<Carrinho> =>
	request.post(`${basePath}/criar`, carrinho)

export const atualizarCarrinho = async (carrinho: Carrinho): Promise<Carrinho> =>
	request.put(`${basePath}/${carrinho.id}`, carrinho)

export const findCarrinhosByTipo = async (params: any, config?: AxiosRequestConfig): Promise<Page<Carrinho>> =>
	request.get(`${basePath}/buscar`, {
		params,
		...config,
	})

export const findByIdentificador = async (identificador: string): Promise<CarrinhoPublico> =>
	request.get(`/public${basePath}/${identificador}`)

export const finalizarMalinhaDoCliente = async (carrinho: CarrinhoPublico): Promise<CarrinhoPublico> =>
	request.post(`/public${basePath}/finalizar`, carrinho)

export const findVendaPublicDoCarrinho = async(carrinhoId: string, vendedorId: string): Promise<Venda> =>
	request.get(`/public${basePath}/venda/${carrinhoId}/${vendedorId}`)

export const relacionarVendaAoCarrinho = async (vendaId: string, carrinhoId: string): Promise<Carrinho> =>
	request.post(`${basePath}/relacionar/${carrinhoId}/${vendaId}`)

export const removerCarrinho = async (idCarrinho: string): Promise<void> =>
	request.delete(`${basePath}/${idCarrinho}`)

export const atualizarTotaisDoCarrinho = async (carrinhoId: string, valorTotal: number, quantidadeDePecas: number): Promise<void> =>
	request.patch(`${basePath}/${carrinhoId}/totais`, { valorTotal, quantidadeDePecas })